import api from "./api";
import qs from "qs";

const CancelReason = {
    async get(id: number) {
        return api.get(`/v1/jobs/cancel-reasons/${id}`).then(res => res.data);
    },
    async list(filters = {}) {
        const query = qs.stringify({ filters });
        return api.get(`/v1/jobs/cancel-reasons?${query}`).then(res => res.data);
    }
};

export default CancelReason;
